import styled from "styled-components";

export const ClassificationWrapper = styled.div`
  position: absolute;
  top: 2.4rem;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: 120rem;
  transform: translate(-50%, 0%);
  z-index: 30;
  box-shadow: 0 0.4rem 1.2rem 0 rgba(7, 68, 161, 0.04);
`;

export const ClassificationContentWrapper = styled.div`
  padding: 0 0.8rem 0.8rem 0.8rem;
`;

export const ClassificationFilterFieldset = styled.fieldset`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
`;

export const ClassificationRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.2rem solid ${({ theme }) => theme.color.neural.gray02};
  padding: 2rem 0rem;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const ClassificationContent = styled.div`
  width: 100%;
  text-align: left;
  word-break: keep-all;
`;

export const ClassificationTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 1.1rem;
  gap: 0.4rem;
  margin: 0 0.8rem 1.6rem 0;
`;

export const ClassificationTitle = styled.h3`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 100%;
`;

export const ConfirmButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  height: 3.2rem;
  margin-top: 2rem;
  background-color: ${({ theme }) => theme.color.node.sky};
  border-radius: 0.8rem;
  padding: 0 1.6rem;
  cursor: pointer;
`;

export const ConfirmButtonText = styled.span`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 100%;
  color: white;
`;

export const ClassificationCloseButton = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ClassificationXMark = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
`;

export const ClassificationCloseText = styled.span`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 100%;
  color: ${({ theme }) => theme.color.live.orange};
`;

export const FilterResetButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  cursor: pointer;

  &:disabled {
    cursor: no-drop;
    span {
      color: ${({ theme }) => theme.color.neural.gray05};
    }
  }
`;

export const FilterResetButtonText = styled.span`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 100%;
  color: ${({ theme }) => theme.color.neural.gray09};
`;
